// Export selectors
export const selectUsersLicenses = (state) => state.dashboard.usersLicenses;
export const selectUsersLicensesInProgress = (state) =>
  state.dashboard.isGetUsersLicensesInProgress;
export const selectUsersLicensesSuccess = (state) =>
  state.dashboard.isGetUsersLicensesSuccess;
export const selectUsersLicensesErrorMsg = (state) =>
  state.dashboard.usersLicensesErrorMsg;

export const selectUsersRenewableLicenses = (state) =>
  state.dashboard.usersRenewableLicenses;
export const selectUsersRenewableLicensesInProgress = (state) =>
  state.dashboard.isGetUsersRenewableLicensesInProgress;
export const selectUsersRenewableLicensesSuccess = (state) =>
  state.dashboard.isGetUsersRenewableLicensesSuccess;
export const selectUsersRenewableLicensesErrorMsg = (state) =>
  state.dashboard.usersRenewableLicensesErrorMsg;

export const selectUsersTaxableLicensePeriods = (state) =>
  state.dashboard.usersTaxableLicenses;
export const selectUsersTaxableLicensePeriodsInProgress = (state) =>
  state.dashboard.isGetUsersTaxableLicensesInProgress;
export const selectUsersTaxableLicensePeriodsSuccess = (state) =>
  state.dashboard.isGetUsersTaxableLicensesSuccess;
export const selectUsersTaxableLicensePeriodsErrorMsg = (state) =>
  state.dashboard.usersTaxableLicensesErrorMsg;
